const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const _ = require("lodash");

const StepWrapper = require("./StepWrapper");
const RadioItem = require("../../office/RadioItem");

const styles = require("./styles/SetSettings.css");

module.exports = createReactClass({
	displayName: "SetCustomerSegment",

	propTypes: {
		studentData: PT.object.isRequired,
		copy: PT.object.isRequired,
		renderButton: PT.func.isRequired,
		handleSubmit: PT.func.isRequired,
		handleBack: PT.func,
		onChange: PT.func.isRequired,
		stepNumber: PT.number.isRequired,
		totalNumSteps: PT.number.isRequired,
	},

	getInitialState: function() {
		return {
			options: [null, null, null],
		};
	},

	answerQuestion: function(i, answer) {
		const options = _.clone(this.state.options);
		options[i] = answer;
		this.setState({options});
		this.props.onChange();
	},

	handleSubmit: function() {
		this.props.handleSubmit(this.state.options);
	},

	renderQuestion: function(q, i) {
		return (
			<div className={styles.segmentContainer} key={"question" + i}>
				<div className={styles.segmentQuestion}>
					<RadioItem
						text={`${q.A}`}
						isSelected={this.state.options[i] === "A"}
						size={"medium"}
						color={"blue"}
						onRight={true}
						onClick={() => this.answerQuestion(i, "A")}
					/>
				</div>
				<div className={styles.segmentQuestion}>
					<RadioItem
						text={`${q.B}`}
						isSelected={this.state.options[i] === "B"}
						size={"medium"}
						color={"blue"}
						onClick={() => this.answerQuestion(i, "B")}
					/>
				</div>
			</div>
		);
	},

	render: function() {
		const wrapperProps = _.pick(this.props, [
			"copy",
			"renderButton",
			"renderError",
			"stepNumber",
			"totalNumSteps",
			"handleBack",
		]);

		const radioRows = _.map(this.props.copy.questions, this.renderQuestion);

		return (
			<StepWrapper {...wrapperProps} handleSubmit={this.handleSubmit}>
				{radioRows}
			</StepWrapper>
		);
	},
});
